import momentFo from 'moment-timezone'

export default {
    install(Vue) {
        Vue.filter('capitalize', function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }),
        Vue.filter('momentTZ', function (strDate, format = "MMMM Do YYYY h:mm A") {
            return momentFo(strDate).tz('America/New_York').format(format);
        }),
        Vue.filter('dimText', function (text, length, suffix) {
            if (text == null) return '';
            return text.substring(0, length) + ((text.length > length) ? suffix : '');
        })
        Vue.filter('stripTags', function (text, length, suffix) {
            if (text == null) return '';
			let regex = /(<([^>]+)>)/ig;
			return text.replace(regex, " ").trim();
        })
        Vue.filter('answer', function (text, length, suffix) {
            if (text == null) return '';
            return text ? 'Yes' : 'No'
        })
    }
}

